module.exports = __webpack_public_path__ + "static/img/medal2.b72b3bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/medal2.png
// module id = hQPW
// module chunks = 1